import React, { useState, useEffect } from 'react'
import Table from '../Community/CommunityTable'
import { useNavigate } from 'react-router-dom';
import { getCommunityApi, deleteCommunityApi, getCommunityCountApi, markImp, downloadcommunityReportByData, GetFiAgentsByPageData } from '../Community/CommunityActionCreator'
import Loader from '../../../../presentationals/Loader/Loader.component'
import DeletePopup from '../Community/deletePopup'
import moment from 'moment'
import { FormControl, InputLabel, MenuItem, Select, Tooltip } from '@mui/material';
import { sortingFunction, paginationFuction } from '../CommonUtils';
import SelectMUI from '../CommonComponents/SelectMUI'

import Pagination from '@mui/material/Pagination';

const agentTypeData = [
    {
        code: "Amu Agent Vendor",
        name: "Amu Agent Vendor",
    },
    {
        code: "Third Party Vendor",
        name: "Third Party Vendor",
    },
]

const CommunityList = ({ handleTab }) => {
    const [searchInput, setSearchInput] = useState({ emailId: '', mobileNo: '', createdOn: '', whoYouAre: '', important: "", communityCode: '', name: '' })

    const [agentType, setagentType] = useState("")

    const [allData, setAllData] = useState([])
    const [loaderState, setLoaderState] = useState(false)
    const [deletePopupState, setDeletePopupState] = useState(false)
    const [idForDelete, setIdForDelete] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [pageNumber, setPageNumber] = useState(1)
    const [noOfRows, setNoOfRows] = useState(10)
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [trigger, setTrigger] = useState(false)
    const [search, setSearch] = useState('mobile')
    const [applyDateToShow, setapplyDateToShow] = useState();
    const [RoleType, setRoleType] = useState("");




    useEffect(() => {
        getAllDataHandler(pageNumber, noOfRows)
    }, [])

    const getAllDataHandler = (page, rows) => {
        setLoaderState(true)

        GetFiAgentsByPageData(rows, page, agentType,
            callBack => {
                setAllData(callBack?.data?.agentsList)
                setTotalCount(callBack?.data?.totalPages)
                setLoaderState(false)
                getCountHandler()
            },
            error => {

            })
    }

    const actionHandler = (type, data) => {
        if (type === 'edit') {

            handleTab(data, "addEdit")
        } else if (type === 'add') {

            handleTab("", "addEdit")
        } else if (type === 'search') {
            getAllDataHandler(1, 10);
            setPageNumber(1)
        }

    }

    const handlePageChange = (event, value) => {
        setPageNumber(value);
        getAllDataHandler(value, noOfRows)
    };

    return (
        <div className='container-fluid '>

            {loaderState ?
                <Loader />
                :
                <div>
                    {/* <div>
                        <h3 style={{ margin: '0px 0 30px 0' }}>Dealer</h3>
                    </div> */}
                    <div className='row '>
                        {/* <div className='col-sm-12 '> */}
                        <div className='col col-md-8' style={{ display: 'flex', margin: '30px 0 30px 0' }}>


                            <div className='col-sm-12 col-md-3 mt-1'>

                                {/* <SelectMUI
                                    value={agentType}
                                    label="Role Type"
                                    onChange={e => { setagentType(e); }}
                                    name="agentType"
                                    data={agentTypeData}
                                    variant={""}
                                    customCSS={{
                                        ".MuiFormLabel-root": {
                                            padding: "0 10px"
                                        }
                                    }}
                                /> */}
                                <select className='form-control' onChange={e => setagentType(e.target.value)} value={agentType}>
                                    <option value={""}>Select Option</option>
                                    {
                                        agentTypeData?.map(val=>{
                                            return(
                                                <option value={val?.code}>{val?.name}</option>
                                            )
                                        })
                                    }
                                </select>



                            </div>
                            <div className='col-sm-12 col-md-2 mt-1'>
                                <div className='btn-group' style={{ display: 'flex' }}>
                                    <button
                                        className='cred-btn center-block mr-2'
                                        onClick={e => actionHandler('search')}
                                        style={{ padding: '11px 12px', background: '#064254' }}><i style={{ fontSize: '20px' }} className='fa fa-search' /></button>

                                    <button
                                        className='cred-btn center-block'
                                        onClick={e => actionHandler('add')}
                                        style={{ padding: '11px 12px', background: '#064254' }}><i style={{ fontSize: '20px' }} className='fa fa-plus' /></button>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-4 col-xs-12" style={{ display: 'flex', margin: '30px 0 30px 0', justifyContent: 'end' }}>
                            <div className='btn-group' style={{ display: 'flex' }}>
                                <button
                                    className='cred-btn center-block mr-3'
                                    onClick={e => handleDownload()}
                                    style={{ padding: '14px 15px', background: '#064254', fontSize: '16px' }}><i className='fa fa-download' /> &nbsp; Download</button>


                            </div>
                        </div> */}

                        <div className='row' style={{ height: 'calc(100% - 50px)', marginTop: '40px', padding: '0 20px' }}>
                            <div className='col-sm-12 full-height' >
                                <div className='table-responsive full-height'>
                                    {allData?.length > 0 ?
                                        <>
                                            <div style={{ overflowX: 'auto' }}>
                                                <table className='table credhub-table'>
                                                    <thead>
                                                        <tr>


                                                            <th scope="col">Agent Name</th>
                                                            <th scope="col">Email Id</th>
                                                            <th scope="col">Mobile No</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Agent Type</th>
                                                            <th scope="col">Created At</th>
                                                            {/* {
                                        rolesData && rolesData.includes("adminCommunityCreateAndEdit") ? */}
                                                            <th scope="col">Edit</th>
                                                            {/* : ""} */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {allData?.map((row, i) => {
                                                            return (
                                                                <>
                                                                    <tr key={i}>
                                                                        <td>{row?.agentName}</td>
                                                                        <td>{row?.emailId}</td>
                                                                        <td>{row?.mobileNo}</td>
                                                                        <td>{row?.status}</td>
                                                                        <td>{row?.agentType}</td>
                                                                        <td>{row?.addedOn} </td>


                                                                        <td>
                                                                            <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                                                <i className='fa fa-edit' />
                                                                            </button>
                                                                            {/* <button className='btn action-btn' onClick={e => actionHandler('delete', row)}>
                                                                                <i className='fa fa-trash-o' />
                                                                            </button> */}
                                                                        </td>

                                                                    </tr>
                                                                </>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>

                                        </>
                                        : null}
                                </div>
                                <div style={{display:'flex',justifyContent:'center', marginTop: '15px' }}>
                                    <Pagination
                                        count={Math.ceil(totalCount)}
                                        page={pageNumber}
                                        onChange={handlePageChange}
                                        color="primary"
                                        variant='outlined' shape="rounded"
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            }
        </div>
    )
}

export default CommunityList;